import { render } from "./EventSourceDistribution.vue?vue&type=template&id=c19202b2"
import script from "./EventSourceDistribution.vue?vue&type=script&lang=js"
export * from "./EventSourceDistribution.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__